import {SUPPORT_PREDEFINED_MULTISELECT_TECHNICAL_IMPORT} from "./import-feature-flags";

/**
 * @param {Array<*>} technicalProperties
 * @returns {boolean}
 */
export const industryHasUnsupportedMultiselectPredefined = (technicalProperties) => {
    if (SUPPORT_PREDEFINED_MULTISELECT_TECHNICAL_IMPORT) {
        return false;
    }
    return (technicalProperties ?? []).some(
        (p) =>
            (p?.config?.hasPreDefinedValues ?? p?.hasPreDefinedValues) &&
            (p?.config?.isMultiSelect ?? p?.isMultiSelect),
    );
};

/**
 * @param {Array<{name: string}>|null|undefined} mappingFields
 * @returns {Set<string>}
 */
export const buildMappedPropertyFieldKeys = (mappingFields) =>
    new Set(
        (mappingFields ?? [])
            .map((field) => field.name)
            .filter((name) => typeof name === 'string' && name.startsWith('property_')),
    );
